<template>
  <div id="RechargeView" class="recharge-view">
    <b-form id="recharge-form" @submit.prevent="save" class="add-news-form pt-3">
      <b-form-row>
        <b-col sm="9">
          <h5>Off period</h5>
          <b-form-group id="recharge-hero" label="Hero image url" labelFor="recharge-hero-input" class="recharge-form-label" description="Enter comlete Imgix URL">
            <b-form-input id="recharge-hero-input" v-model="recharge.hero" name="recharge-hero-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-hero-top" label="Hero top" labelFor="recharge-hero-top-input" class="recharge-form-label" description="Smaller text displayed above hero title">
            <b-form-input id="recharge-hero-top-input" v-model="recharge.heroTop" name="recharge-hero-top-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-hero-h1" label="Hero h1" labelFor="recharge-hero-h1-input" class="recharge-form-label">
            <b-form-input id="recharge-hero-h1-input" v-model="recharge.heroH1" name="recharge-hero-h1-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-hero-h2" label="Hero h2" labelFor="recharge-hero-h2-input" class="recharge-form-label">
            <b-form-input id="recharge-hero-h2-input" v-model="recharge.heroH2" name="recharge-hero-h2-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-hero-cta" label="Hero button text" labelFor="recharge-hero-cta-input" class="recharge-form-label">
            <b-form-input id="recharge-hero-cta-input" v-model="recharge.heroCta" name="recharge-hero-cta-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="1"></b-col>
        <b-col sm="2">
          <b-form-group id="recharge-language" label="Select a language" labelFor="recharge-language-select" class="recharge-language-label">
            <multiselect id="recharge-language-select" v-model="locale" :options="languages" label="name" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col sm="9">
          <h5>Promo period</h5>
          <b-form-group id="recharge-promo-hero" label="Hero image url" labelFor="recharge-promo-hero-input" class="recharge-form-label" description="Enter comlete Imgix URL">
            <b-form-input id="recharge-promo-hero-input" v-model="recharge.promoHero" name="recharge-promo-hero-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-promo-hero-top" label="Hero top" labelFor="recharge-promo-hero-top-input" class="recharge-form-label" description="Smaller text displayed above hero title">
            <b-form-input id="recharge-promo-hero-top-input" v-model="recharge.promoHeroTop" name="recharge-promo-hero-top-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-promo-hero-h1" label="Hero h1" labelFor="recharge-promo-hero-h1-input" class="recharge-form-label">
            <b-form-input id="recharge-promo-hero-h1-input" v-model="recharge.promoHeroH1" name="recharge-promo-hero-h1-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-promo-hero-h2" label="Hero h2" labelFor="recharge-promo-hero-h2-input" class="recharge-form-label">
            <b-form-input id="recharge-promo-hero-h2-input" v-model="recharge.promoHeroH2" name="recharge-promo-hero-h2-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-promo-hero-cta" label="Hero button text" labelFor="recharge-promo-hero-cta-input" class="recharge-form-label">
            <b-form-input id="recharge-promo-hero-cta-input" v-model="recharge.promoHeroCta" name="recharge-promo-hero-cta-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-promo-hero-fineprint" label="Hero fineprint" labelFor="recharge-promo-hero-fineprint-input" class="recharge-form-label" description="Promo period date range e.g. Valid June 25 - June 30">
            <b-form-input id="recharge-promo-hero-fineprint-input" v-model="recharge.promoHeroFineprint" name="recharge-promo-hero-fineprint-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col sm="9">
          <h5>Prebook period</h5>
          <b-form-group id="recharge-prebook-hero" label="Hero image url" labelFor="recharge-prebook-hero-input" class="recharge-form-label" description="Enter comlete Imgix URL">
            <b-form-input id="recharge-prebook-hero-input" v-model="recharge.prebookHero" name="recharge-prebook-hero-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-prebook-hero-top" label="Hero top" labelFor="recharge-prebook-hero-top-input" class="recharge-form-label" description="Smaller text displayed above hero title">
            <b-form-input id="recharge-prebook-hero-top-input" v-model="recharge.prebookHeroTop" name="recharge-prebook-hero-top-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-prebook-hero-h1" label="Hero h1" labelFor="recharge-prebook-hero-h1-input" class="recharge-form-label">
            <b-form-input id="recharge-prebook-hero-h1-input" v-model="recharge.prebookHeroH1" name="recharge-prebook-hero-h1-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-prebook-hero-h2" label="Hero h2" labelFor="recharge-prebook-hero-h2-input" class="recharge-form-label">
            <b-form-input id="recharge-prebook-hero-h2-input" v-model="recharge.prebookHeroH2" name="recharge-prebook-hero-h2-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-prebook-hero-cta" label="Hero button text" labelFor="recharge-prebook-hero-cta-input" class="recharge-form-label">
            <b-form-input id="recharge-prebook-hero-cta-input" v-model="recharge.prebookHeroCta" name="recharge-prebook-hero-cta-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
          <b-form-group id="recharge-prebook-hero-fineprint" label="Hero fineprint" labelFor="recharge-prebook-hero-fineprint-input" class="recharge-form-label" description="Promo period date range e.g. Valid June 25 - June 30">
            <b-form-input id="recharge-prebook-hero-fineprint-input" v-model="recharge.prebookHeroFineprint" name="recharge-prebook-hero-fineprint-input" :disabled="isLoading" required></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="submit">
        <b-col cols="12" sm="12">
          <b-button type="submit" size="lg" variant="primary" :disabled="isLoading">Save</b-button>
        </b-col>
      </b-form-row>
    </b-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Recharge',
  async mounted () {
    await this.loadByLocale()
  },
  methods: {
    ...mapActions({
      'fetchRecharge': 'recharge/fetchRecharge',
      'saveRecharge': 'recharge/saveRecharge'
    }),
    async loadByLocale () {
      await this.fetchRecharge(this.locale.id)
      let r = this.$store.state.recharge.recharge
      this.recharge = Object.assign({}, r)
    },
    save () {
      this.saveRecharge(this.locale.id).then(() => {
        this.$toastr.s('Recharge saved')
      }).catch((error) => {
        this.$toastr.e(error)
      })
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'loader/isLoading'
    })
  },
  watch: {
    locale: {
      handler (newValue) {
        if (newValue.id !== undefined) {
          this.locale = newValue
          this.loadByLocale()
        }
      }
    },
    recharge: {
      handler (newValue) {
        this.$store.dispatch('recharge/setRecharge', newValue)
      },
      deep: true
    }
  },
  data () {
    return {
      locale: {id: 'en', name: 'English'},
      recharge: {},
      languages: [{id: 'en', name: 'English'}, {id: 'es', name: 'Spanish'}, {id: 'fr', name: 'French'}]
    }
  }
}
</script>
<style lang="scss" scoped>

.has-error {
  color: #ff0000;
  input {
    border-color: #ff0000;
  }
}
.submit{
  margin-top: 20px;
}

h5{
  margin-bottom: 20px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/recharge/Index.vue